// 页面英文
import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  language: {
    name: 'English'
  },
  message: {
    1000: 'Username is empty',
    1001: 'Password is empty',
    1002: 'The account and password do not match',
    1003: 'User does not exist',
    1004: 'Unsupported encryption mode',
    1005: 'User already exists',
    1006: 'Passing in the role ID is empty',
    1007: 'The account cannot be deleted',
    1008: 'Passing in the old password is empty',
    1009: 'Passing in the new password is empty',
    1010: 'Passing in the phone number is empty',
    1011: 'The parent account does not exist',
    1012: 'Passing in the confirmation password is empty',
    1013: 'The two password entries do not match',
    2100: 'Without the permission',
    9000: 'Passing parameter is empty',
    9005: 'Token is not included in the HEAD information',
    9006: 'OpenID is not included in the HEAD information',
    9007: 'Invalid OpenID',
    9008: 'Invalid Token',
    9010: 'Invalid platform',
    9011: 'Invalid Parameter',
    19001: 'The electricity bill configuration is not filled in',
    19002: 'The charging direction is not specified on a device. Procedure',
    19003: 'The device whose meter category is not set exists',
    error: 'System error',
    login: 'Login Success!',
    logout: 'Logout Success!',
    exit: 'Are you sure to logout?'
  },
  notice: {
    title: 'Notice',
    message: 'The default language of the website has been switched to English',
    sc: 'This operation will delete the plant. Continue or not',
    sccg: 'Delete the success',
    zd: 'A maximum of five items can be selected',
    sfsc: 'Whether to delete this alarm',
    sfcl: 'Whether to handle this alarm',
    clcg: 'Handle success',
    qr: 'ok',
    qx: 'cancel',
    gxpch: 'This operation will update the batch number, whether to continue',
    gxcg: 'Succeeded in updating the batch number!',
    qxgx: 'Update cancelled',
    cxsc: 'The attachment format is wrong, please delete and upload again！',
    scfj: 'Please upload the attachment！',
    znscyg: 'Only one file can be uploaded',
    drcg: 'Success import',
    xgcg: 'Changed success',
    yjsc: 'This operation permanently deletes selected item data. Continue or not',
    qxsc: 'Cancelled delete',
    zsyg: 'Please select at least one option',
    tjcg: 'Submitted successfully ',
    scsb: 'This operation will delete the selected device. Continue or not',
    qxsqcg: 'Authorization cancelled successfully',
    qxsq: 'This operation will cancel authorization. Select the device and decide whether to continue',
    sqcg: 'Authorization successfully',
    sq: 'This operation authorizes the selected device. Continue or not',
    xgyh: 'Succeeded in modifying a User',
    scyh: 'This operation will delete the user and its power station, continue or not？',
    yhsccg: 'Deleting a user succeeded',
    yhtjcg: 'User Added Successfully',
    czmm: 'This operation will reset the user password to 123456. Continue？',
    czcg: 'User password reset successful',
    mmbyz: 'The passwords entered are different',
    tgyz: 'Please verify first',
    qdtc: 'Are you sure you want to log out',
    zccg: 'Registered successfully',
    qxcl: 'Cancelled processing',
    bjcg: 'edit success',
    tjsbcg: 'Adding a device Succeeded',
    tjsb: 'Submit failed',
    sfjb: 'Determine whether to unbind the device',
    chChangeGatewayByMeter: 'Are you sure about replacing the collector?',
    jbcg: 'Unbundling success',
    xgsbcg: 'Device Modification succeeded',
    qxjb: 'Cancel the unbundling',
    sbbdcg: 'Device binding successful',
    sblbwk: 'Device list is empty',
    sjszcg: 'Data setting successful',
    qxsz: 'Cancel settings',
    sfjc: 'Confirm whether to disarm the device',
    jccg: 'Remove success',
    sbsc: 'Are you sure you want to delete this device',
    bycfsr: 'Do not enter the SN number again',
    xzcg: 'New success',
    changeGatewayByMeterSuccess: 'Collector replaced successfully',
    qdsc: 'Confirm delete',
    tips: 'Tips',
    yes: 'Yes',
    no: 'No',
    qsrfsfl: 'Please enter time-share rate'
  },
  placeholder: {
    sxtbm: 'Enter alias',
    sxtssdz: 'Enter orgname',
    sxtxlh: 'Enter gatewaysn',
    username: 'Username',
    password: 'Password',
    xzdz: 'Please select power station',
    dzmc: 'Please enter the name of the plant',
    kssj: 'Please enter the start time',
    jssj: 'Please enter the end time',
    sbxlh: 'Please enter the device serial number',
    sim: 'Please enter the SIM card number',
    srxlh: 'Please enter serial number',
    jmm: 'Please enter old password',
    xmm: 'Please enter new password',
    qrmm: 'Please affirm password',
    zcsr: 'Please enter the new password again',
    qzcsr: 'Please enter the password again',
    qxxsbzt: 'Select device status',
    qxxsb: 'Select device',
    srdb: 'Please enter the meter sn',
    srcjq: 'Please enter collector sn',
    xzrq: 'Please select the date and time',
    xzid: 'Please select device ID',
    srnbq: 'Please enter the inverter SN'
  },
  button: {
    mr: 'default',
    cq: 'restart',
    login: 'Sign In',
    logout: 'Logout',
    cx: 'search',
    fh: 'back',
    sc: 'delete',
    qr: 'ok',
    qx: 'cancel',
    cl: 'handle',
    zc: 'register',
    dlz: 'login.....',
    tj: 'submit',
    xzmb: 'download template',
    dgdr: 'single import',
    plsc: 'batch delete',
    ggpch: 'change batch number',
    pldr: 'batch import',
    bj: 'edit',
    qd: 'ok',
    sq: 'authorization',
    qxsq: 'cancel authorization',
    tianjia: 'add',
    czmm: 'reset',
    bc: 'save',
    xg: 'change',
    xyb: 'next',
    syb: 'previous',
    xzsn: 'new SN',
    zjdl: 'direct login',
    fhdl: 'back login',
    yl: 'preview',
    dc: 'export',
    sz: 'set',
    bd: 'bind',
    djsz: 'set price',
    cssz: 'parameter set',
    sjsz: 'time set',
    csyl: 'initial preview',
    csdc: 'initial export',
    xz: 'add',
    bcsz: 'save settings',
    xzpz: 'configuration',
    cjzd: 'create terminal',
    cj: 'create',
    cz: 'recharge',
    phonesetting: 'Set phone number',
    changeGateway: 'Replace the collector',
    changeGatewayByMeterSuccess: 'The collector has been successfully replaced.'
  },
  msg: {
    xzdzlx: 'Please select a site type',
    sryhm: 'Please enter a user name',
    zslwyhm: 'Please enter at least two characters',
    srmm: 'Please enter password',
    qsrmm: 'Enter a password of 6 to 20 characters',
    qzcsrmm: 'Please enter your password again',
    qsrzdmc: 'Please enter a site name',
    stationNameNoSlash: 'The site name cannot contain / or \\',
    qsrzjrl: 'Please enter installed capacity',
    qsrdj: 'Please input electricity price',
    qsrdw: 'Please select monetary unit',
    qsrsn: 'Please enter the collector SN',
    qsrqydz: 'Select an area address',
    qsrsf: 'Please select a province',
    qsrsq: 'Please select a time zone',
    ints: 'Enter an integer from 0 to 24',
    sfsc: 'Whether to delete the configuration',
    phonecannotbeempty: 'Mobile phone number cannot be empty, at least one must be set!',
    phonesetsuccess: 'Successfully set mobile phone number!',
  },
  param: {
    gzms: 'work mode',
    zfzy: 'spontaneous use',
    xftg: 'peak peel ',
    dcyx: 'battery is preferred',
    dcfdsd: 'battery discharge depth',
    dccddl: 'battery charging current',
    bwgldd: 'grid-connected power scheduling',
    dcfdgldd: 'battery discharge power scheduling',
    glys: 'power factor',
    wggl: 'reactive power',
    dwdyxx: 'grid voltage lower limit',
    dwdysx: 'grid voltage upper limit',
    dwplxx: 'grid frequency lower limit',
    dwplsx: 'grid frequency upper limit',
    dctxfs: 'battery communication mode',
    yy: 'language',
    zw: 'chinese',
    yw: 'english',
    fnl: 'backflow prevention',
    jz: 'forbid',
    yx: 'allow',
    pvsrlx: 'PV Input type',
    dl: 'independent',
    bl: 'parallel connection',
    hy: 'constant pressure',
    zly: 'dc source',
    qsdc: 'lead-acid battery',
    ldc: 'lithium battery',
    dccddy: 'battery charging voltage',
    pvgldd: 'PV power scheduling',
    dccdbhdy: 'battery charging protection voltage',
    gjdwbz: 'national grid standard',
    az: 'Australia',
    azx: 'Western Australia',
    xxl: 'New Zealand',
    yg: 'UK',
    dg: 'Germany',
    hg: 'South Korea',
    flb: 'Philippines',
    zg: 'China',
    mg: 'USA',
    tg: 'Thailand'
  },
  dialog: {
    nbqsn: 'inverter SN：',
    nbqzt: 'inverter state：',
    bjxx: 'alarm info：',
    bjsj: 'alarm time：',
    wcxx: 'side info',
    pl: 'frequency：',
    nbqwd: 'inverter temperature：',
    axgl: 'A phase power：',
    bxgl: 'B phase power：',
    cxgl: 'C phase power：',
    hjwd: 'environment temperature：',
    axdl: 'A phase current：',
    bxdl: 'B phase current：',
    cxdl: 'C phase current：',
    axdy: 'A phase voltage：',
    bxdy: 'B phase voltage：',
    cxdy: 'C phase voltage：',
    fzcxx: 'load side info',
    axfzdy: 'A phase load line voltage：',
    bxfzdy: 'B phase load line voltage：',
    cxfzdy: 'C phase load line voltage：',
    axfzl: 'A phase load factor：',
    bxfzl: 'B phase load factor：',
    cxfzl: 'C phase load factor：',
    axfzdl: 'A phase load line current：',
    bxfzdl: 'B phase load line current：',
    cxfzdl: 'C phase load line current：',
    axfzgl: 'A phase load power：',
    bxfzgl: 'B phase load power：',
    cxfzgl: 'C phase load power：',
    dccxx: 'battery info',
    dcdl: 'battery current：',
    dcdl1: 'battery current1：',
    dcdl2: 'battery current2：',
    dcdl3: 'battery current3：',
    dcsydl: 'remaining battery：',
    dcwd: 'battery temperature：',
    cddy: 'charging voltage：',
    cdxlz: 'charging current limit：',
    fdxlz: 'discharge current limit：',
    dcdy: 'battery voltage：',
    pvcxx: 'PV info',
    pv1dy: 'PV1 voltage：',
    pv2dy: 'PV2 voltage：',
    pv3dy: 'PV3 voltage：',
    pv4dy: 'PV4 voltage：',
    pv1dl: 'PV1 current：',
    pv2dl: 'PV2 current：',
    pv3dl: 'PV3 current：',
    pv4dl: 'PV4 current：',
    pv1gl: 'PV1 power：',
    pv2gl: 'PV2 power：',
    pv3gl: 'PV3 power：',
    pv4gl: 'PV4 power：',
    zjmnl: 'complete machine analog',
    zbus: 'positive BUS voltage：',
    fbus: 'negative BUS voltage：',
    dcwendu: 'DC temperature：',
    drfadl: 'daily power generation：',
    dyfadl: 'month power generation：',
    dnfadl: 'year power generation：',
    zfadl: 'total power generation：',
    drfdl: 'daily discharge：',
    dyfdl: 'month discharge：',
    dnfdl: 'year discharge：',
    zfdl: 'total discharge：',
    drhdl: 'daily power consumption：',
    dyhdl: 'month power consumption：',
    dnhdl: 'year power consumption：',
    zhdl: 'total power consumption：',
  },
  sec: {
    nbqsn: 'inverter SN',
    nbqzt: 'inverter state',
    bjxx: 'alarm info',
    bjsj: 'alarm time',
    wcxx: 'side info',
    pl: 'frequency',
    nbqwd: 'inverter temperature',
    axgl: 'A phase power',
    bxgl: 'B phase power',
    cxgl: 'C phase power',
    hjwd: 'environment temperature',
    axdl: 'A phase current',
    bxdl: 'B phase current',
    cxdl: 'C phase current',
    axdy: 'A phase voltage',
    bxdy: 'B phase voltage',
    cxdy: 'C phase voltage',
    fzcxx: 'load side info',
    axfzdy: 'A phase load line voltage',
    bxfzdy: 'B phase load line voltage',
    cxfzdy: 'C phase load line voltage',
    axfzl: 'A phase load factor',
    bxfzl: 'B phase load factor',
    cxfzl: 'C phase load factor',
    axfzdl: 'A phase load line current',
    bxfzdl: 'B phase load line current',
    cxfzdl: 'C phase load line current',
    axfzgl: 'A phase load power',
    bxfzgl: 'B phase load power',
    cxfzgl: 'C phase load power',
    dccxx: 'battery info',
    dcdl: 'battery current',
    dcdl1: 'battery current1',
    dcdl2: 'battery current2',
    dcdl3: 'battery current3',
    dcsydl: 'remaining battery',
    dcwd: 'battery temperature',
    cddy: 'charging voltage',
    cdxlz: 'charging current limit',
    fdxlz: 'discharge current limit',
    dcdy: 'battery voltage',
    pvcxx: 'PV info',
    pv1dy: 'PV1 voltage',
    pv2dy: 'PV2 voltage',
    pv3dy: 'PV3 voltage',
    pv4dy: 'PV4 voltage',
    pv1dl: 'PV1 current',
    pv2dl: 'PV2 current',
    pv3dl: 'PV3 current',
    pv4dl: 'PV4 current',
    pv1gl: 'PV1 power',
    pv2gl: 'PV2 power',
    pv3gl: 'PV3 power',
    pv4gl: 'PV4 power',
    zjmnl: 'complete machine analog',
    zbus: 'positive BUS voltage',
    fbus: 'negative BUS voltage',
    dcwendu: 'DC temperature',
    drfadl: 'daily power generation',
    dyfadl: 'month power generation',
    dnfadl: 'year power generation',
    zfadl: 'total power generation',
    drfdl: 'daily discharge',
    dyfdl: 'month discharge',
    dnfdl: 'year discharge',
    zfdl: 'total discharge',
    drhdl: 'daily power consumption',
    dyhdl: 'month power consumption',
    dnhdl: 'year power consumption',
    zhdl: 'total power consumption',
  },
  text: {
    pdldjyhxs: '平电量电价优惠系数',
    fdldjyhxs: '峰电量电价优惠系数',
    gdldjyhxs: '谷电量电价优惠系数',
    jdldjyhxs: '尖电量电价优惠系数',
    jdldj: '尖电量电价',
    sxtbm: 'alias',
    sxtssdz: 'orgname',
    sxtxlh: 'gatewaysn',
    cjsj: 'createtime',
    type: 'type',
    cjzdyh: 'create terminal user',
    ysds: 'original',
    user: 'End User',
    super: 'Super User',
    ok: 'OK',
    cancel: 'Cancel',
    tip: 'Tips',
    forget: 'Forget Password?',
    noaccount: 'Do you still not have an account?',
    register: 'Please register now',
    fdxx: 'power generation information',
    dz: 'station',
    yh: 'user',
    jk: 'monitor',
    nbq: 'inverter',
    dqgl: 'Current power generation capacity',
    zjrl: 'installed capacity',
    drdl: 'energy today',
    drfdl: 'daily power generation',
    dydl: 'energy month',
    dndl: 'energy year',
    zdl: 'energy total',
    hddz: 'activity power station',
    zdz: 'total power station',
    dyxz: 'the month of new',
    dnxz: 'the year of new',
    zyh: 'total user',
    hdsb: 'activity equipment',
    yazsb: 'installed equipment',
    zsb: 'total equipment',
    zxnbq: 'in-line inverter',
    bjnbq: 'alarm inverter',
    lxnbq: 'off-line inverter',
    zs: 'total',
    qt: 'other',
    zgl: 'total power',
    nbqsl: 'inverter quantity',
    cjqsl: 'collector quantity',
    zfdl: 'total generating capacity',
    dzzs: 'total stations',
    stationCount: "station count",
    zx: 'online',
    tpzd: 'Picture site',
    lbzd: 'List site',
    dzmc: 'station name',
    grxx: 'personal information',
    dqzd: 'current site',
    zt: 'state',
    zdlx: 'site type',
    ljdl: 'cumulative power',
    ljfdl: 'cumulative power generation',
    gxsj: 'update time',
    upload_time: 'upload time',
    cz: 'operation',
    zc: 'string',
    qx: 'weather',
    cn: 'energy',
    db: 'meter',
    orgtype_switch: 'switch',
    t: 'day',
    y: 'month',
    n: 'year',
    minutes: 'minutes',
    seconds: 'seconds',
    zj: 'total',
    qxxz: 'deselect',
    sjxz: 'timechoose',
    gfxt: 'PV-system',
    kssj: 'starttime',
    jssj: 'endtime',
    xh: 'number',
    rq: 'date',
    cjqsn: 'collectorSN',
    nbqsn: 'inverterSN',
    bjlx: 'alarmtype',
    bjzt: 'alarmstate',
    dzxz: 'station choose',
    jzmm: 'remember the password',
    smxz: 'scan code to download android or ios App',
    sbxlh: 'gatwaySN',
    jyzt: 'verify state',
    sim: 'SIM number  ',
    bm: 'alias',
    sblx: 'device type',
    txlx: 'types of communication',
    jy: 'verify',
    ms: 'description',
    drsj: 'import time',
    qb: 'all',
    jycg: 'verify success',
    jysb: 'verify failure',
    xlh: ' serial number',
    sbbm: 'alias',
    fxs: 'distributor',
    azs: 'installer',
    zdyh: 'terminal',
    fxshazs: 'installer or terminal',
    qxz: 'please select',
    yhmc: 'username',
    qymc: 'companyname',
    yhm: 'username',
    jsm: 'rolename',
    sj: 'mobile',
    yx: 'email',
    gs: 'company',
    zhdlsj: 'last login',
    zcsj: 'regist date',
    yhbj: 'user edit',
    mm: 'password',
    sjhm: 'mobile',
    gsmc: 'company',
    dzyx: 'email',
    jmm: 'old password',
    xmm: 'new password',
    qrmm: 'affirm password',
    yhxx: 'userInfo',
    zdxx: 'siteInfo',
    zddz: 'siteAddress',
    dzlx: 'siteType',
    zdtp: 'sitePicture  ',
    zdmc: 'siteName',
    dj: 'price',
    hbdw: 'monetary unit',
    azr: 'installer',
    azrdh: 'installer mobile',
    cjqlb: 'Gateways',
    controlSystem: 'control',
    qydz: 'area address',
    jwd: 'longitude and latitude',
    xxdz: 'detail address',
    shiqu: 'timezone',
    dwsz: 'Positioning Settings',
    jd: 'longitude：',
    wd: 'latitude：',
    dizhi: 'address：',
    xxzqydz: 'Select an area address first',
    lct: 'flow chart',
    fdqs: 'power trends',
    dztp: 'site picture',
    jnjpsr: 'Income from energy emission reduction',
    dxzsl: 'equivalent trees planted',
    ljsr: 'accumulat income',
    co2: 'CO₂ emission reductions',
    gl: 'power',
    cjqxlh: 'collector SN',
    nbqxlh: 'inverter SN',
    meterSerialNumber: 'meter SN',
    slave_address: 'Slave address',
    zlsr: 'dc input',
    jlsc: 'ac input',
    td: 'channel',
    dy: 'voltage(V)',
    current: 'current(A)',
    xw: 'phase',
    pl: 'frequency(Hz)',
    wendu: 'temperature(℃)',
    tpwd: 'chip temperature(℃)',
    shijian: 'time',
    gonglv: 'power(kw)',
    zongdl: 'energy total(kwh)',
    lb: 'category',
    r: 'day',
    z: 'total',
    cs: 'parameter',
    sb: 'device',
    dl: 'current',
    dianya: 'voltage',
    wdu: 'temperature',
    dwpl: 'grid frequency',
    zglv: 'total power',
    jlscdyr: 'Ac output voltage R',
    jlscdlr: 'Ac output current R',
    jlscdys: 'Ac output voltage S',
    jlscdls: 'Ac output current S',
    jlscdyt: 'Ac output voltage T',
    jlscdlt: 'Ac output current T',
    dn: 'electricity',
    fdn: 'power generation',
    rbb: 'daily report',
    gailan: 'overview ',
    meter_month_first_last_history: '{month} 1st and last 1st historical data',
    rdl: 'day power',
    mx: 'detail',
    jldy: 'Ac voltage',
    zldy: 'Dc voltage',
    pinlv: 'frequency',
    ybb: 'month report',
    nbb: 'year report',
    ydl: 'month power',
    ndl: 'year power',
    nfdl: 'year power generation',
    zcdzmc: 'station name',
    tp: 'picture',
    sbzt: 'device state',
    xgsb: 'change device',
    tjsb: 'add device',
    zhenc: 'normal',
    bfzx: 'part of the online',
    lx: 'offline',
    bj: 'alarm',
    sbsn: 'deviceSN',
    dblx: 'meter type',
    sbyt: 'device purpose',
    yddb: ' electricity meter',
    gfdb: 'photovoltaic meter',
    bdsb: 'bind deive',
    dkdp: 'open big screen',
    ssz: 'instant',
    yggl: 'effective power',
    zxdl: 'positive power',
    fxdl: 'reverse power',
    wggl: 'reactive power',
    glqx: 'power curve',
    glys: 'power factor',
    bl: 'ratio',
    axdl: 'A phase current',
    bxdl: 'B phase current',
    cxdl: 'C phase current',
    axdy: 'A phase voltage',
    bxdy: 'B phase voltage',
    cxdy: 'C phase voltage',
    axyggl: 'A phase active power',
    bxyggl: 'B phase active power',
    cxyggl: 'C phase active power',
    axwggl: 'A phase reactive power',
    bxwggl: 'B phase reactive power',
    cxwggl: 'C phase reactive power',
    zyggl: 'total active power',
    zwggl: 'total reactive power',
    jsd: 'sharp',
    fsd: 'peak',
    psd: 'flat',
    gsd: 'valley',
    gnxz: 'feature selection：',
    xzn: 'choose year',
    xzy: 'choose month',
    zf: 'forward/reverse',
    j: 'sharp',
    f: 'peak',
    p: 'flat',
    g: 'valley',
    dvalley: 'dvalley',
    fdl: 'peak',
    pdl: 'flat',
    gdl: 'valley',
    jdl: 'sharp',
    dvalleyEnergy: 'deep valley',
    rifdl: 'day peak',
    rpdl: 'day flat',
    rgdl: 'day valley',
    rjdl: 'day sharp',
    dayDvlleyEnergy: 'day deep valley',
    z1: 'total',
    dbxlh: 'meter SN',
    zxzdl: 'total power forward',
    fxzdl: 'total power reverse',
    tysj: 'commissioning time',
    dldyzbl: 'current/voltage/total',
    blbm: 'change ratio/alias',
    dlbl: 'current ratio',
    dybl: 'voltage ratio',
    zbl: 'total ratio',
    sbid: 'device ID',
    zxj: 'positive sharp electricity',
    zxf: 'positive peak electricity',
    zxp: 'positive flat electricity',
    zxg: 'positive valley electricity',
    fxj: 'reverse sharp electricity',
    fxf: 'reverse peak electricity',
    fxp: 'reverse flat electricity',
    fxg: 'reverse valley electricity',
    dbdzmc: 'station name',
    rhz: 'Daily summary of electricity meter data',
    yhz: 'Monthly summary of electricity meter data',
    nhz: 'Annual summary of electricity meter data',
    zxjs: 'positive sharp electricity',
    zxfs: 'positive peak electricity',
    zxps: 'positive flat electricity',
    zxgs: 'positive valley electricity',
    fdvlley: 'positive deep valley electricity',
    fxjs: 'reverse sharp electricity',
    fxfs: 'reverse peak electricity',
    fxps: 'reverse flat electricity',
    fxgs: 'reverse valley electricity',
    rdvlley: 'reverse deep valley electricity',
    pdj: '平电量电价',
    gdj: '谷电量电价',
    fdj: '峰电量电价',
    dvalley_price: '深谷电价',
    grid_price: "上网电价",
    pxs: 'flat coefficient',
    gxs: 'valley coefficient',
    fxss: 'peak coefficient',
    dlgl: 'the current power',
    nlph: 'energy balance for today',
    sy: 'earnings',
    jygj: 'savings in total',
    rsr: 'day of income',
    ysr: 'month of income',
    nsr: 'year of income',
    zsr: 'total income',
    ks: 'tree',
    jp: 'reduce emissions',
    yuan: 'yuan',
    wcgl: 'side power',
    fdgl: 'generation power',
    fzgl: 'load power',
    nbqbm: 'inverter alias',
    dianliu: 'current(A)',
    xq: 'details',
    nbqxq: 'inverter details',
    bjztz: 'alarm status',
    rfadl: 'daily power generation',
    rfdl: 'daily discharge',
    rhdl: 'daily electricity consumption',
    yfadl: 'month power generation',
    yfdl: 'month discharge',
    yhdl: 'month electricity consumption',
    nfangdl: 'year discharge',
    nhdl: 'year electricity consumption',
    zfangdl: 'total discharge',
    zhdl: 'total power consumption',
    fz: 'load',
    dianc: 'battery',
    cndzmc: 'station name',
    sbxx: 'equipment details',
    mc: 'name',
    sbh: 'device',
    qy: 'pressure',
    fs: 'radiation',
    dqqy: 'current pressure',
    sd: 'humidity',
    fengs: 'wind speed',
    fx: 'wind direction',
    dqfx: 'current wind direction',
    df: 'east',
    nf: 'south',
    xf: 'west',
    bf: 'north',
    dbf: 'northeast',
    dnf: 'southeast',
    xnf: 'southwest',
    xbf: 'northwest',
    zd: 'east',
    zn: 'south',
    zhx: 'west',
    zb: 'north',
    dob: 'northeast',
    don: 'southeast',
    xn: 'southwest',
    xb: 'northwest',
    ffengs: 'speed(m/s)',
    ffx: 'direction(°)',
    fqy: 'pressure(hpa)',
    ffs: 'radiation(w/m²)',
    fsds: 'humidity(%rh)',
    rain: 'rain(mm)',
    rainstrength: 'rainstrength (mm/h)',
    qxy: 'atmospherium',
    qxsblb: 'List of meteorological equipment',
    rwsj: 'net time',
    qxzmc: 'station name',
    ycl: 'processed',
    wcl: 'untreated',
    cg: 'succeed',
    sbai: 'failed',
    qh: 'Switching between English and Chinese:',
    dbmc: 'meter name',
    sjjg: 'time interval',
    sblb: 'device list',
    srsn: 'enter SN',
    dfdtt: 'Set the head of electricity bill',
    dfdsz: 'Electricity bill setting',
    bt: 'title',
    zhcxdh: 'accountTel',
    zhcxgzsj: 'accountTime',
    gzwxdh: 'faultsTel',
    gzwxsj: 'faultsTime',
    jjdh: 'emergencyTel',
    jjgzsj: 'emergencyTime',
    ybcxyx: 'generalEmail',
    yhxx1: 'userInfo1',
    yhxx2: 'userInfo2',
    yhdz1: 'userAddr1',
    yhdz2: 'userAddr2',
    fpdh: 'invoicenumPre',
    fpdcs: 'invoicenum',
    csdj: 'price',
    zdydj: 'customPrice',
    djyxj: 'priority',
    zjfl: 'ratio',
    pzmc: 'name',
    sfmr: 'default',
    sfsx: 'effective',
    s: 'yes',
    fou: 'no',
    psjd: 'flat time',
    fsjd: 'peak time',
    jsjd: 'sharp time',
    gsjd: 'valley time',
    dvalleyTimeRange: 'deep valley time range',
    deepvalleydaterange: 'dvalley time',
    sxkssj: 'effective starttime',
    sxjssj: 'effective endtime',
    xzfssz: 'New Time-sharing Settings',
    fspzmc: 'configuration name',
    ratesdetail: 'timeshare details',
    bjfssz: 'Edit time-sharing Settings',
    fspz: 'timeshare',
    fsyysz: 'Time-sharing application Settings',
    tjfs: 'statistical pattern',
    czsl: 'examples',
    dfdsz1: 'bill setting',
    dfdttsz: 'head setting',
    zcnbq: 'cluster inverter',
    cnnbq: 'energy inverter',
    rzj: 'day sharp/total sharp',
    rzf: 'day peak/total peak',
    rzp: 'day flat/total flat',
    rzg: 'day valley/total valley',
    dqsj: 'expiration time',
    card: 'card',
    pay: 'pay',
    amountpayable: 'Amount payable',
    rmainingpaymenttime: 'Remaining payment time',
    ordercancelledalert: 'Otherwise, the order will be cancelled automatically',
    generatingorder: 'Generating order',
    onlyalipay: 'Currently, only Alipay payment is supported',
    paymentsucceeded: 'Payment succeeded!',
    paymentsucceedednotify: 'We will confirm and renew the payment as soon as possible after the payment is completed!',
    orderexpirednotify: 'The order has expired. Please place the order again.',
    description: 'description',
    remainingsms: 'Remaining SMS',
    mobilephone: 'Mobile phone',
    offlinepush: 'Offline notify',
    a: 'a',
    gateway: 'gateway',
    default: 'default',
    remarkLink: 'remark link',
    fsflmc: 'Time-share Rate Name',
    qsrfsflmc: 'Please enter time-share rate name',
    qsrfgwglj: 'Please enter NDRC announcement link',
    fgwglj: 'NDRC Announcement Link',
    xzfsfl: 'Add Time-share Rate',
    bjfsfl: 'Edit Time-share Rate',
    qsrxzjd: 'Please select time period',
    tjsd: 'Add Time Period',
    stationProvince: 'station province',
    stationTimezone: 'station timezone',
    stationBelongProvince: 'province',
    deviceList: 'Device list',
    registerWelcome: 'Welcome to register on the BlueSpider new platform',
    loginWelcome: 'Welcome to the BlueSpider new platform',
    loginTip: 'Welcome back, please sign in with your account',
    collectorListTip: 'Enter the collector SN(s) of this station. Multiple SNs are allowed',
    meterMultiplier: 'meter rate',
  },
  head: {
    hyn: 'Welcome'
  },
  sider: {
    switch_control_system: 'Switch control system',
    switch_real_control: 'Switch control',
    switch_realtime: 'Switch Real',
    switch_parameter_settings: 'Switch Parameter settings',
    switch_cloud_timing: 'Switch cloud timing',
    switch_local_timing: 'Switch cocal timing',
    switch_countdown: 'Switch countdown',
    spjk: 'Video',
    xtgk: 'System overview',
    xtlb: 'System list',
    xtbj: 'Comparison',
    bjzx: 'Alarm center',
    sbdr: 'Device import',
    sbsq: 'Authorization',
    yhgl: 'Management',
    wdxx: 'My Info',
    xgmm: 'Change password',
    gk: 'Overview',
    sssj: 'Realtime data',
    lssj: 'History data',
    ycsz: 'Remote set',
    cjqlb: 'Gateways',
    bbxz: 'Report download',
    bjlb: 'Alarm list',
    cndzsz: 'Station set',
    sjgk: 'Overview',
    dbfx: 'Compara analysis',
    sslb: 'Realtime list',
    zdsjcx: 'Whole time data',
    bbdc: 'Export',
    bb: 'Report',
    dbdzsz: 'Station set',
    cbcd: 'Meter read menu',
    zcdzsz: 'Station set',
    dp: 'Large screen',
    sblb: 'Device list',
    sjcx: 'Data query',
    qxdzsz: 'Station set',
    xzdd: 'New site',
    dfxd: 'Electricity Invoice',
    dfdsz: 'Bill setting',
    fscx: 'Time-share query',
    dnsj: 'Electric',
    tjdl: 'statistical',
    rynbb: 'DYM-report',
    zdbb: 'whole report',
    bbdc2: 'export',
    jsbg: 'settlement',
    tcgl: 'Package management',
    deviceRecharge: 'Gateway renewal',
    offlineNotify: 'Offline notify',
    logo: 'logo',
    switchStationSet: 'Station set'
  },
  bghn: {
    dlcc: 'ElectricityOutput',
    brfdl: 'DailyPower',
    brzfzydl: 'DailySelfPower',
    byfdl: 'MonthlyPower',
    drdlqx: 'DailyPowerCurve',
    dydlqx: 'MonthlyPowerCurve',
    drsy: 'DailyRevenue',
    dysy: 'MonthlyRevenue',
    r: 'Day',
    m: '-',
    jnjp: 'EnergyConservation',
    co2jp: 'CO₂Reduction',
    dxlz: 'TreePlanting',
    k: 'Tree',
    nlph: 'EnergyBalance',
    ssgl: 'RealTimePower',
    ljfd: 'CumulativePowerGeneration',
    fdl: 'PowerGeneration',
    swdl: 'GridConnectedPower',
    zfzy: 'Self-usePower',
    dzxx: 'SiteInfo',
    dzzt: 'SiteState',
    zx: 'Online',
    bfzx: 'PartialOnline',
    lx: 'Offline',
    bj: 'Alarm',
    dzlx: 'SiteType',
    gsydz: 'CommercialIndustrialStation',
    bwsj: 'MergeTime',
    dzdz: 'SiteAddress',
    dxfd: 'EquivalentPower',
    zjrl: 'InstalledCapacity',
    rdxfdxs: 'DailyEquivalentPowerGeneration',
    ydxfdxs: 'MonthlyEquivalentPowerGeneration',
    dz: '150 Xiya Road, Pudong New Area, Shanghai',
  },
  // element-ui language package
  ...enLocale
}

export default en
